var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-resize-toggler",class:[("theme-" + _vm.theme), { 'is-expanded': !_vm.collapsed }],style:(_vm.style),on:{"click":_vm.onClick}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-591a70e7","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/button/button-resize-toggler.vue
// module id = 3108
// module chunks = 0